var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Down 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.448148 1.28213C0.936303 0.793977 1.72776 0.793977 2.21591 1.28213L12.9987 12.0649L23.7815 1.28213C24.2696 0.793977 25.0611 0.793977 25.5492 1.28213C26.0374 1.77029 26.0374 2.56174 25.5492 3.0499L13.8826 14.7166C13.3944 15.2047 12.603 15.2047 12.1148 14.7166L0.448148 3.0499C-0.0400076 2.56174 -0.0400076 1.77029 0.448148 1.28213Z",
    fill: "#72788E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/downIcon.cf5193c952db77c38439586079271841.svg";
export { ForwardRef as ReactComponent };